import {
    BRANDS,
    BUSINESS,
    COMMUNITY_IMPACT,
    SUSTAINABILITY,
    CLEAR_ALL,
    PRESS_RELEASE,
    AWARDS,
    MINDFUL_SNACKING,
    SNACKING_MADE_RIGHT,
    CAREERS_AND_PEOPLE
    
  } from "./filterValue.constants"
export const filtersData = {
    items:[
    {
      id: "1",
      label: BRANDS,
      name: BRANDS
    },
    {
      id: "2",
      label: BUSINESS,
      name: BUSINESS
    },
    {
      id: "3",
      label: CAREERS_AND_PEOPLE,
      name: CAREERS_AND_PEOPLE
    },
    {
      id: "4",
      label: COMMUNITY_IMPACT,
      name: COMMUNITY_IMPACT
    },
    {
      id: "5",
      label: SUSTAINABILITY,
      name: SUSTAINABILITY
    },
    {
      id: "6",
      label: CLEAR_ALL,
      name: CLEAR_ALL
    }
  ]}
  export const filtersDataUK = {
    items:[
    {
      id: "1",
      label: PRESS_RELEASE,
      name: PRESS_RELEASE
    },
    {
      id: "2",
      label: AWARDS,
      name: AWARDS
    },
    {
      id: "3",
      label: BUSINESS,
      name: BUSINESS
    },
    {
      id: "4",
      label: COMMUNITY_IMPACT,
      name: COMMUNITY_IMPACT
    },
    {
      id: "5",
      label: MINDFUL_SNACKING,
      name: MINDFUL_SNACKING
    },
    {
      id: "6",
      label: SNACKING_MADE_RIGHT,
      name: SNACKING_MADE_RIGHT
    },
    {
      id: "7",
      label: CLEAR_ALL,
      name: CLEAR_ALL
    }
  ]}
  